import { createContext } from 'react';
import { IItemForGetShortInfoWithStatus, TPropertiesOfPatchChangesForSubcategory } from 'types';

export type TTypeOfModalWindow = Nullable<'toConfirmFieldsClearing' | 'error'>;

export interface ISaveAsPatchState {
	initialFormData: {
		categoryId: string;
		customerName: string;
		categoryName: string;
		fetchedRestaurants: IItemForGetShortInfoWithStatus[];
		IDSelectedRestaurantOnRestPropsPage: Nullable<string>;
		hasSchedulePriority: boolean;
		activationSchedule: string;
		deactivationSchedule: string;
		availableForRepetition: boolean;
		isHidden: boolean;
	};
	typeOfChanges: 'basedChanges' | 'independentChanges';
	IDsSelectedRestaurant: string[];
	activationSchedule: string;
	deactivationSchedule: string;
	availableForRepetition: boolean;
	isHidden: boolean;
	selectedProperties: TPropertiesOfPatchChangesForSubcategory[];
	typeOfModalWindow: TTypeOfModalWindow;
}

export const saveAsPatchInitialState: ISaveAsPatchState = {
	initialFormData: {
		categoryId: '',
		customerName: '',
		categoryName: '',
		fetchedRestaurants: [],
		IDSelectedRestaurantOnRestPropsPage: null,
		hasSchedulePriority: false,
		activationSchedule: '',
		deactivationSchedule: '',
		availableForRepetition: false,
		isHidden: false,
	},
	typeOfChanges: 'basedChanges',
	IDsSelectedRestaurant: [],
	activationSchedule: '',
	deactivationSchedule: '',
	availableForRepetition: false,
	isHidden: false,
	selectedProperties: [],
	typeOfModalWindow: null,
};

export interface ISaveAsPatchContext extends ISaveAsPatchState {
	saveData(value: 'saveAndMakeOtherChanges' | 'saveAndClose'): void;
	setTypeOfChanges(value: ISaveAsPatchState['typeOfChanges']): void;
	setIDsRestaurant(value: ISaveAsPatchState['IDsSelectedRestaurant']): void;
	setProperties: (value: ISaveAsPatchState['selectedProperties']) => void;
	changeActivationSchedule(value: ISaveAsPatchState['activationSchedule']): void;
	changeDeactivationSchedule(value: ISaveAsPatchState['deactivationSchedule']): void;
	toggleAvailableForRepetition(): void;
	toggleIsHidden(): void;
	changeTypeOfModalWindow(value: ISaveAsPatchState['typeOfModalWindow']): void;
}

export const SaveAsPatchContext = createContext<ISaveAsPatchContext>({
	saveData: () => undefined,
	setTypeOfChanges: () => undefined,
	setIDsRestaurant: () => undefined,
	setProperties: () => undefined,
	changeActivationSchedule: () => undefined,
	changeDeactivationSchedule: () => undefined,
	toggleAvailableForRepetition: () => undefined,
	toggleIsHidden: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...saveAsPatchInitialState,
});
